import React, { useEffect } from "react";
import { Img } from "react-image";
import { useNavigate } from "react-router-dom";
import thankyou from "./../Assets/thankyou_image.jpg";

function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    // Replace the current entry in the history stack
    window.history.replaceState(null, document.title, window.location.href);

    // Prevent going back
    const handlePopState = (event) => {
      // Prevent default back navigation
      event.preventDefault();

      // Redirect to a specific route (e.g., dashboard)
      navigate("/dashboard", { replace: true });
    };

    // Add event listener for popstate
    window.addEventListener("popstate", handlePopState);

    // Prevent default browser back button
    window.history.pushState(null, document.title, window.location.href);

    // Cleanup function
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <Img src={thankyou} height={500} width={500} style={{ margin: "0" }} />
        <h2>Thank You for Your Submission</h2>
        <p>Your ticket has been successfully processed.</p>
      </div>
    </div>
  );
}

export default ThankYou;
